var UserError;
(function (UserError) {
    UserError["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    UserError["EMAIL_REQUIRED"] = "EMAIL_REQUIRED";
    UserError["INVALID_EMAIL"] = "INVALID_EMAIL";
    UserError["EMAIL_NOT_FOUND"] = "EMAIL_NOT_FOUND";
    UserError["PASSWORD_MIN_LENGTH"] = "PASSWORD_MIN_LENGTH";
    UserError["INVALID_PASSWORD"] = "INVALID_PASSWORD";
    UserError["PASSWORD_REQUIRED"] = "PASSWORD_REQUIRED";
    UserError["USER_REQUIRED"] = "USER_REQUIRED";
    UserError["INVALID_USER"] = "INVALID_USER";
    UserError["TOKEN_REQUIRED"] = "TOKEN_REQUIRED";
    UserError["INVALID_TOKEN"] = "INVALID_TOKEN";
    UserError["NAME_REQUIRED"] = "NAME_REQUIRED";
    UserError["INVALID_NAME"] = "INVALID_NAME";
    UserError["NAME_MIN_LENGTH"] = "NAME_MIN_LENGTH";
    UserError["USER_NOT_FOUND"] = "USER_NOT_FOUND";
    UserError["AUTHORIZATION_NOT_FOUND"] = "AUTHORIZATION_NOT_FOUND";
    UserError["ROLES_REQUIRED"] = "ROLES_REQUIRED";
    UserError["INVALID_ROLES"] = "INVALID_ROLES";
    UserError["PICTUREURL_REQUIRED"] = "PICTUREURL_REQUIRED";
    UserError["INVALID_PICTUREURL"] = "INVALID_PICTUREURL";
    UserError["REPLY_REQUIRED"] = "REPLY_REQUIRED";
    UserError["INVALID_REPLY"] = "INVALID_REPLY";
    UserError["THERE_IS_NO_OTHER_ADMINISTRATOR"] = "THERE_IS_NO_OTHER_ADMINISTRATOR";
})(UserError || (UserError = {}));
export default UserError;
